import { inject, Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { IUnternehmenResponse } from '@shared-ikp/model/company-http.model';
import { API_ROUTE_SEARCH_ACCOUNTS, API_ROUTE_SEARCH_UNTERNEHMEN, getApiUrl } from '../../app.constants';
import { catchError, Observable } from 'rxjs';
import { UnternehmenSearchRequest } from '../../model/unternehmen-search-request.model';
import { IkpPopupService } from '@shared-ikp/service/popup/popup.service';
import { AccountViewResponse } from '../../model/account-http.model';

@Injectable({
  providedIn: 'root',
})
export class UnternehmenService extends ApiService {
  private readonly popupService = inject(IkpPopupService);

  searchUnternehmen(unternehmenSearchRequest: UnternehmenSearchRequest): Observable<IUnternehmenResponse> {
    return this.httpClient.post<IUnternehmenResponse>(getApiUrl(this.apiUrl, API_ROUTE_SEARCH_UNTERNEHMEN), unternehmenSearchRequest).pipe(
      catchError(error => {
        this.handleErrorCompanySearch();
        throw error;
      }),
    );
  }

  searchAccounts(unternehmenSearchRequest: UnternehmenSearchRequest): Observable<AccountViewResponse> {
    return this.httpClient.post<AccountViewResponse>(getApiUrl(this.apiUrl, API_ROUTE_SEARCH_ACCOUNTS), unternehmenSearchRequest).pipe(
      catchError(error => {
        this.handleErrorCompanySearch();
        throw error;
      }),
    );
  }

  private handleErrorCompanySearch(): void {
    this.popupService.handleErrorPopup('search-companies-error', 'global.errors.companySection.title');
  }
}
